import React from 'react'

interface ContextProps {
  hasInstallationWritingRights: boolean
}

export const InstallationAccessRightsContext = React.createContext<ContextProps>({ hasInstallationWritingRights: false })

export const useInstallationAccessRightsContext = (): ContextProps => {
  return React.useContext(InstallationAccessRightsContext)
}
